/**
 * @flow
 * @relayHash 5c0fbfd952d1dda6a61486615cfcba69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getCategoryDefaultFlowTemplateQueryVariables = {|
  categoryPk: number
|};
export type getCategoryDefaultFlowTemplateQueryResponse = {|
  +getCategoryDefaultFlowTemplate: ?{|
    +pk: ?number,
    +name: string,
  |}
|};
export type getCategoryDefaultFlowTemplateQuery = {|
  variables: getCategoryDefaultFlowTemplateQueryVariables,
  response: getCategoryDefaultFlowTemplateQueryResponse,
|};
*/


/*
query getCategoryDefaultFlowTemplateQuery(
  $categoryPk: Int!
) {
  getCategoryDefaultFlowTemplate(categoryPk: $categoryPk) {
    pk
    name
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "categoryPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "categoryPk",
    "variableName": "categoryPk",
    "type": "Int!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "getCategoryDefaultFlowTemplateQuery",
  "id": "7eefccf194f19724ecaaa075c2c2b590",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "getCategoryDefaultFlowTemplateQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getCategoryDefaultFlowTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "WorkflowTemplateType",
        "plural": false,
        "selections": [
          v2,
          v3
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getCategoryDefaultFlowTemplateQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getCategoryDefaultFlowTemplate",
        "storageKey": null,
        "args": v1,
        "concreteType": "WorkflowTemplateType",
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
node.text = "query getCategoryDefaultFlowTemplateQuery(\n  $categoryPk: Int!\n) {\n  getCategoryDefaultFlowTemplate(categoryPk: $categoryPk) {\n    pk\n    name\n    id\n  }\n}\n";
(node/*: any*/).hash = '677c93ac841c00829a479088346ded38';
module.exports = node;
